import React, { Component } from 'react'
import { Query, withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'

import { MESSAGES_QUERY } from 'graphql/queries'
import {
  DELETE_MESSAGE,
  SCHEDULE_MESSAGE,
  DUPLICATE_MESSAGE,
} from 'graphql/mutations'
import format from 'date-fns/format'

import { Container, Header, Table, Button } from 'semantic-ui-react'
import { Dialog } from '@reach/dialog'
import InfiniteScroll from 'react-infinite-scroller'

import Loader from 'components/Loader'

const DIALOGS = {
  send: 'send',
  schedule: 'schedule',
}

class MessageList extends Component {
  state = {
    focusedMessageId: '',
    showDialog: false,
    dialog: '',
    date: '',
    time: '',
    limit: 20,
    offset: 0,
    hasMore: true,
  }

  renderSendNowModal() {
    return (
      <React.Fragment>
        <p>Are you sure you want to send this message?</p>
        <div style={{ textAlign: 'center' }}>
          <Button
            primary
            onClick={() => {
              this.props.client
                .mutate({
                  mutation: SCHEDULE_MESSAGE,
                  variables: { id: this.state.focusedMessageId },
                  refetchQueries: [{ query: MESSAGES_QUERY }],
                })
                .then(() =>
                  this.setState({
                    focusedMessageId: '',
                    showDialog: false,
                    dialog: '',
                  }),
                )
            }}
          >
            Yes
          </Button>
        </div>
      </React.Fragment>
    )
  }

  renderScheduleModal() {
    const { focusedMessageId, date, time } = this.state
    return (
      <React.Fragment>
        <p>Schedule Message For Later</p>
        <p>Select a date and time</p>

        <label htmlFor="date">Date</label>
        <input
          id="date"
          type="date"
          value={date}
          onChange={event => {
            this.setState({ date: event.target.value })
          }}
        />

        <label htmlFor="time">Time</label>
        <input
          id="time"
          type="time"
          value={time}
          onChange={event => {
            this.setState({ time: event.target.value })
          }}
        />

        <Button
          primary
          onClick={() => {
            let dateParts = date.split('-')
            dateParts[1] = Number(dateParts[1]) - 1
            const timeParts = time.split(':')
            const scheduled = +new Date(...dateParts, ...timeParts)
            this.props.client
              .mutate({
                mutation: SCHEDULE_MESSAGE,
                variables: { id: focusedMessageId, scheduled },
                refetchQueries: [{ query: MESSAGES_QUERY }],
              })
              .then(() =>
                this.setState({
                  focusedMessageId: '',
                  showDialog: false,
                  dialog: '',
                }),
              )
          }}
        >
          Schedule
        </Button>
      </React.Fragment>
    )
  }

  formatStatus = (scheduled, sentAt) => {
    const wasSent = !!sentAt
    const isScheduled = !!scheduled
    let timestamp = Date.now()
    let statusMessage
    if (wasSent) {
      timestamp = sentAt
      statusMessage = 'Sent at'
    } else if (isScheduled) {
      timestamp = scheduled
      statusMessage = 'Scheduled for'
    } else {
      return 'Draft'
    }
    return `${statusMessage} ${format(timestamp, 'M/DD/YY h:mm a')}`
  }

  renderRow = ({ id, updated, sentAt, scheduled, topic, data }) => {
    let name = ''
    let type = ''
    if (data) {
      name = data.name
      type = data.type
    }

    const status = this.formatStatus(scheduled, sentAt)

    return (
      <Table.Row key={id}>
        <Table.Cell width={3}>{name}</Table.Cell>
        <Table.Cell>{type}</Table.Cell>
        <Table.Cell>{topic}</Table.Cell>
        <Table.Cell>{status}</Table.Cell>
        <Table.Cell>
          <div style={{ marginBottom: 4 }}>
            <Link to={`/messages/edit/${id}`}>
              <Button primary>Edit</Button>
            </Link>
            <Button
              color="red"
              onClick={() => {
                this.props.client.mutate({
                  mutation: DELETE_MESSAGE,
                  variables: { id },
                  refetchQueries: [{ query: MESSAGES_QUERY }],
                })
              }}
            >
              Delete
            </Button>
          </div>
          <div>
            <Button
              basic
              secondary
              disabled={sentAt}
              onClick={() =>
                this.setState({
                  focusedMessageId: id,
                  showDialog: true,
                  dialog: DIALOGS.send,
                })
              }
            >
              Send
            </Button>

            <Button
              disabled={sentAt}
              basic
              secondary
              onClick={() =>
                this.setState({
                  focusedMessageId: id,
                  showDialog: true,
                  dialog: DIALOGS.schedule,
                })
              }
            >
              {scheduled && !sentAt ? 'Unschedule' : 'Schedule'}
            </Button>
            <Button
              basic
              secondary
              onClick={() => {
                this.props.client.mutate({
                  mutation: DUPLICATE_MESSAGE,
                  variables: { id },
                  refetchQueries: [{ query: MESSAGES_QUERY }],
                })
              }}
            >
              Duplicate
            </Button>
          </div>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="Messages" />
          <Link to="/messages/new">
            <Button primary>New Message</Button>
          </Link>
        </div>

        <Query query={MESSAGES_QUERY}>
          {({ data, loading, error, fetchMore }) => {
            if (loading) {
              return <Loader />
            }

            if (error) {
              console.error(error)
              return <div>Failed to fetch messages.</div>
            }

            return (
              <React.Fragment>
                <InfiniteScroll
                  loadMore={() =>
                    fetchMore({
                      variables: { offset: data.messages.length },
                      updateQuery: (prev, { fetchMoreResult, variables }) => {
                        if (!fetchMoreResult) return prev
                        if (!fetchMoreResult.messages.length) {
                          this.setState({ hasMore: false })
                        }
                        return {
                          ...prev,
                          messages: [
                            ...prev.messages,
                            ...fetchMoreResult.messages,
                          ],
                        }
                      },
                    })
                  }
                  hasMore={this.state.hasMore}
                  loader={<Loader />}
                >
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Title</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Send To</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Actions</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{data.messages.map(this.renderRow)}</Table.Body>
                  </Table>
                </InfiniteScroll>

                <Dialog isOpen={this.state.showDialog}>
                  <Button
                    style={{ float: 'right' }}
                    onClick={() =>
                      this.setState({
                        focusedMessageId: '',
                        showDialog: false,
                        dialog: '',
                      })
                    }
                  >
                    X
                  </Button>
                  {this.state.dialog === DIALOGS.send
                    ? this.renderSendNowModal()
                    : this.renderScheduleModal()}
                </Dialog>
              </React.Fragment>
            )
          }}
        </Query>
      </Container>
    )
  }
}

export default withApollo(MessageList)
